import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from 'components/Context/AppContext';
import { AreaCharter, Button, InputField, TableWrapper } from 'components/Global';
import ImageViewer from 'components/Global/ImageViewer';
import AddOnsField from 'components/Global/AddOnsField';

import { ReactComponent as MappinIcon } from 'icons/mappin-icon.svg';
import { ReactComponent as ReuploadIcon } from 'icons/reupload-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderAddOnsById } from 'features/orders/actions';

import { ReactComponent as Duration } from 'icons/duration-icon.svg';
import { ReactComponent as Calendar } from 'icons/calendar-icon.svg';
import { ReactComponent as CarCharterIcon } from 'icons/car-charter-filled-icon.svg';

import VehicleDetailComponent from 'components/HomeComponent/Content/DetailOrderCarCharterComponent/DetailOrder/VehicleDetailComponent';
import RentTimeDetailComponents from 'components/HomeComponent/Content/DetailOrderCarCharterComponent/DetailOrder/RentTimeDetailComponents';
import { getAllRentalLocation } from 'features/rental-location/actions';
import DriverData from 'components/HomeComponent/Content/DetailOrderCarCharterComponent/DetailOrder/DriverData';
import { checkEmptyObject, getKTPValue, getPassportValue, mappedAreaCharter } from 'utils/functionality';
import { useSearchParams } from 'react-router-dom';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';

const getPaymentValue = (data) => {
  return data?.type === 'FULL'
    ? 'Pembayaran Full'
    : data?.type === 'HALF'
    ? `Pembayaran DP ${
        data?.order_detail?.dp_rule?.formula_percentage?.value
          ? `${data.order_detail.dp_rule.formula_percentage.value}%`
          : ''
      }`
    : '-';
};

const CarCharterTask = ({ data, customer, selectedDriverTaskData, selectedCountry, transactionKey, setShowImage }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const { setShowReviewIdentityModal, setShowConfirmation, setShowCancelTaskCharter } = useAppContext();
  const { data: allLocationData } = useSelector((state) => state.rentalLocation);
  const { selected: selectedDriver } = useSelector((state) => state.drivers);

  const isCharterIdentityReviewEnabled = useFliptBoolean('FLAG_FE_REVIEW_IDENTITY_CHARTER', false, 'anonymous');
  const isUploadNewDocumentEnabled = useFliptBoolean('FLAG_FE_NEW_UPLOAD_DOCUMENT', false, 'anonymous');

  useEffect(() => {
    dispatch(getOrderAddOnsById(transactionKey));
    dispatch(getAllRentalLocation());
  }, [transactionKey]);

  const backHandler = () => {
    navigate(-1);
  };

  const handleRequestCancelOrder = () => {
    setShowConfirmation({
      message: 'Apakah anda yakin ingin membatalkan pesanan ini?',
      show: true,
      onClick: async () => {
        searchParams.set('driver_id', selectedDriver?.id);
        setSearchParams(searchParams);
        setShowCancelTaskCharter(true);
      },
    });
  };

  return (
    <TableWrapper icon={<CarCharterIcon fill="#009EF7" width="25px" height="25px" />} title="Car Charter">
      <div className="detail-car-charter__form">
        {selectedDriverTaskData && !checkEmptyObject(selectedDriverTaskData) && !checkEmptyObject(selectedDriver) && (
          <div className="detail-driver">
            <h2>Data Driver</h2>
            <DriverData driverData={selectedDriver} />
          </div>
        )}

        <div className="detail-penyewa">
          <h2>Detail Penyewa</h2>
          <div className="detail-penyewa__data">
            <InputField
              label="Lokasi"
              disable
              readOnly
              icon={<MappinIcon />}
              iconPosition={'start'}
              value={allLocationData?.find((loc) => loc.id === data?.order_detail?.location_id)?.name || '-'}
            />

            <InputField label="Name" disable readOnly value={data?.user_name || '-'} />

            <div className="detail-penyewa__data__phone-number">
              <InputField
                label="No Handphone"
                readOnly
                disable
                value={data?.is_admin_creation ? data?.phone_country_code : customer?.phone_code || '-'}
                icon={
                  <img
                    src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                    width={26}
                    height={16}
                    alt={selectedCountry?.name + ' nation flag'}
                  />
                }
                iconPosition={'end'}
              />
              <InputField value={data?.phone_number || '-'} disable readOnly />
            </div>

            <InputField label="Email" disable readOnly value={data?.email || '-'} />

            <ImageViewer
              label="KTP"
              value={getKTPValue(data, customer, isUploadNewDocumentEnabled)}
              onClick={(image) => setShowImage({ show: true, image })}
              customButton={
                isCharterIdentityReviewEnabled &&
                (data?.order_status === 'PAID' || data?.order_status === 'REVIEWING_IDENTITY') && (
                  <>
                    <Button type="button" onClick={() => setShowReviewIdentityModal({ type: 'ktp', show: true })}>
                      Tinjau
                    </Button>
                    {customer?.PersonalInfos?.need_review_ktp && (
                      <div className="reupload-icon">
                        <ReuploadIcon />
                        <p>Upload ulang KTP</p>
                      </div>
                    )}
                  </>
                )
              }
            />

            <ImageViewer
              label="Passport"
              value={getPassportValue(data, customer, isUploadNewDocumentEnabled)}
              onClick={(image) => setShowImage({ show: true, image })}
            />
          </div>
        </div>

        <div className="detail-hari">
          <h2>Detail Hari</h2>
          <div className="detail-hari__data">
            <InputField
              label="Tanggal Mulai"
              icon={<Calendar />}
              iconPosition={'start'}
              disable
              readOnly
              value={data?.order_detail?.start_booking_date || '-'}
            />
            <InputField
              label="Durasi Charter"
              icon={<Duration />}
              iconPosition={'start'}
              disable
              readOnly
              value={data?.order_detail?.booking_zones ? `${data.order_detail.booking_zones?.length} Hari` : '-'}
            />
            <div className="detail-sewa__data__rent-charter-time">
              <RentTimeDetailComponents
                durationRent={data?.order_detail?.booking_zones ? data.order_detail.booking_zones?.length : 0}
                startDate={
                  data?.order_detail?.start_booking_date ? new Date(data?.order_detail?.start_booking_date) : new Date()
                }
                allRentTime={mappedAreaCharter(data, data?.order_detail?.vehicle?.charter_pricing)}
              />
            </div>
          </div>
        </div>

        <div className="detail-sewa">
          <h2>Detail Sewa</h2>
          <div className="detail-sewa__data">
            <div className="detail-sewa__data__selected-car">
              <VehicleDetailComponent data={data} />
            </div>

            <InputField label="Tipe Pembayaran" disable readOnly value={getPaymentValue(data)} />

            <InputField
              label="Jumlah Penumpang"
              disable
              readOnly
              value={`${data?.order_detail?.adult_passenger} Adult, ${data?.order_detail?.child_passenger} Child, ${data?.order_detail?.baggage} Suitcase`}
            />
          </div>
        </div>

        <div className="detail-area-charter">
          <h2>Detail Area Charter</h2>
          <AreaCharter
            durationRentDate={data?.order_detail?.booking_zones ? data?.order_detail?.booking_zones?.length : 0}
            startDate={
              data?.order_detail?.start_booking_date ? new Date(data?.order_detail?.start_booking_date) : new Date()
            }
            allAreaCharter={data?.order_detail?.booking_zones ?? []}
            disable
          />
        </div>

        <div className="detail-additional">
          <h2>Permintaan Khusus</h2>
          <AddOnsField data={data?.addons} totalPrice={data?.addon_total_price} label={false} />
        </div>

        <div className="detail-action-btn">
          <Button variant="outline" className="button" width={208} size="sm" onClick={backHandler}>
            Kembali
          </Button>

          {selectedDriverTaskData?.status !== 'CANCEL' && selectedDriverTaskData?.status !== 'FINISH' && (
            <Button size="sm" className="button" width={208} variant="danger" onClick={handleRequestCancelOrder}>
              Cancel Order
            </Button>
          )}
        </div>
      </div>
    </TableWrapper>
  );
};

export default CarCharterTask;
